<template>
  <div class="contribution">
    <v-container class="pt-6">
      <v-btn text color="pink" @click="$func.goBack()">
        <v-icon small class="mr-2">fa-chevron-left</v-icon>
        返回
      </v-btn>
      <v-list dark class="transparent">
        <v-list-item 
          v-for="(member, i) in members" 
          :style="i == 0 ? 'background-color: #ebba46' : i == 1 ? 'background-color: #919191' : i == 2 ? 'background-color: #d17e54' : ''"
        >
          <div class="mr-6 title" :style="i == 0 ? 'color: #966e17' : i == 1 ? 'color: #494949' : i == 2 ? 'color: #7d4830' : ''">{{ i + 1 }}</div>
          <v-menu 
            bottom 
            open-on-hover 
            content-class="profile-card"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex" v-bind="attrs" v-on="on">
                <v-list-item-avatar class="mr-4">
                  <v-img :src="$HOST_URL + member.usericon"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ member.nickname }}</v-list-item-title>
                </v-list-item-content>
              </div>
            </template>
            <v-card class="pa-4">
              <v-list-item class="pa-0 mb-4">
                <v-list-item-avatar size="50" tile>
                  <v-avatar tile>
                    <v-img :src="$HOST_URL + member.usericon"/>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-regular mb-1">
                    {{ member.nickname }}
                  </v-list-item-title>
                  <!-- <v-rating
                    x-small
                    dense
                    readonly
                    half-increments
                    :value="5"
                    background-color="yellow darken-2"
                    color="yellow darken-2"
                  ></v-rating> -->
                </v-list-item-content>
              </v-list-item>
              <span>
                <v-btn dark v-if="true" block class="mt-4 pink">追蹤用戶</v-btn>
                <v-btn dark v-else block class="mt-4 pink">取消追蹤</v-btn>
              </span>
              <span @click.stop="block(member.id)">
                <v-btn v-if="!isBlock(member.id)" dark block color="red darken-2" class="mt-4">封鎖</v-btn>
                <v-btn v-else dark block outlined color="red darken-2" class="mt-4">已封鎖</v-btn>
              </span>
            </v-card>
          </v-menu>
          <v-spacer></v-spacer>
          <v-list-tile-action class="d-flex">
            <div class="peach mr-1"></div>
            <v-list-item-title>{{ member.total_contribution }}</v-list-item-title>
          </v-list-tile-action>
        </v-list-item>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      members: []
    }
  },
  created() {
    this.getContribution()
  },
  computed: {
    ...mapState('seller', ['blockList'])
  },
  methods: {
    getContribution() {
      this.axios('/portal/rank').then(response => {
        this.members = response.data
      })
    },
    isBlock(id) {
      return this.blockList.map(member => member.id).includes(id)
    },
    block(id) {
      this.axios.post('/portal/block', {
        member_id: id
      }).then(response => {
        this.$store.dispatch('seller/getBlockList')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contribution {
  .v-list-item {
    color: white;
    margin: 8px 0;
    padding: 8px 16px;
    background-color: $grey-2;
  }
}
</style>